// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { Authenticated } from '../auth';
import ViewProvider from './ViewProvider';

export default {
  path: 'provider',
  name: 'Provider',
  component: Authenticated,
  childRoutes: [
    { path: '', component: ViewProvider },
  ],
};
